module.exports = __webpack_public_path__ + "assets/images/JMDC20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDC20.png
// module id = 1400
// module chunks = 1